module.exports = __webpack_public_path__ + "static/media/km.30680397.svg";